<template>
    <div class="guide-wrapper page-content">
        <b-tabs type="is-boxed" v-model="tabSelected" :destroy-on-hide="true">
            <b-tab-item label="Slider" value="slider" id="slider-tab" ref="slider">
                <slider v-if="sliderShow"/>
            </b-tab-item>
            <b-tab-item label="Steps Management" v-if="isRole('superadmin')" value="steps" id="steps-tab">
                <step :topicId="topicId" @topic="stepsClicked"/>
            </b-tab-item>
            <b-tab-item label="Topics Management" v-if="isRole('superadmin')" value="topics" id="topics-tab">
                <topic @step="stepsClicked"/>
            </b-tab-item>
            <b-tab-item label="App Management" v-if="isRole('superadmin')" value="apps" id="apps-tab">
                <test-results/>
            </b-tab-item>
            <b-tab-item label="Diagrams" value="diagrams" id="diagrams-tab">
                <diagram/>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
import Slider from './includes/slider';
import Step from './children/steps/step';
import Topic from './children/topics/topic';
import TestResults from './children/test-results/test-results';
import Diagram from './children/diagram/index';

export default {
    name:"Guide",
    components: {
        Slider,
        Step,
        Topic,
        TestResults,
        Diagram
    },
    data(){
        return{
            tabSelected:'slider',
            topicId:null,
            sliderShow:true
        }
    },
    mounted(){
        if(this.$router.currentRoute.query.tabSelected){
            this.tabSelected = this.$router.currentRoute.query.tabSelected
            // Clear query params
            this.$router.replace({ query: {} });
        }
    },
    methods:{
        stepsClicked(id) {
            this.tabSelected='steps',
            this.topicId=id
        },
    }
}
</script>